export const trackNavClick = (
  category?: string,
  subCategory?: string,
  subSubCategory?: string,
  text?: string,
  url?: string,
) => {
  if (typeof window !== "undefined") {
    let formattedUrl = url || "";
    // If the URL is a relative path, convert it to an absolute URL using GATSBY_HOST
    if (formattedUrl.startsWith("/")) {
      const host = process.env.GATSBY_HOST || "https://www.shine.fr";
      formattedUrl = `${host}${formattedUrl}`;
    }

    window.dataLayer = window.dataLayer || [];
    const eventPayload = {
      event: "click_menu_header",
      menu_item_category: category || "",
      menu_item_sub_category: subCategory || "",
      menu_item_sub_sub_category: subSubCategory || "",
      link_text: text || "",
      link_url: formattedUrl,
    };
    window.dataLayer.push(eventPayload);
  }
};
